import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  clear() {
    if (!document.hidden && "clearAppBadge" in navigator) {
      navigator.clearAppBadge()
    }
  }
}
